module.exports = "/packs/016-a77d9311ce5414314cc8c1cf97b8cb05.jpg";